export class ApiError extends Error {
  constructor(
    message: string,
    public httpCode: number,
    public data: unknown,
  ) {
    super(message);
  }
}
